// import { Component, signal } from '@angular/core';
// import { RouterOutlet } from '@angular/router';
// import { ToastModule } from 'primeng/toast'
// // import { ButtonComponent } from './shared/layout/components/button/button';
// // import { AppLayout } from './shared/layout/components/app.layout';


// @Component({
//   selector: 'app-root',
//   standalone: true,
//   imports: [RouterOutlet, ToastModule],
//   // templateUrl: './app.html',
//   // styleUrls: ['./app.css']
//   template: `<p-toast></p-toast>
//               <router-outlet></router-outlet>`
// })
// export class App {
//   protected readonly title = signal('portal');
// }

import { Component, signal, inject } from '@angular/core';
import {
  RouterOutlet,
  Router,
  NavigationStart,
  NavigationEnd,
  NavigationCancel,
  NavigationError
} from '@angular/router';
import { ToastModule } from 'primeng/toast';
import { NgIf } from '@angular/common';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { PrimeNG } from 'primeng/config';

import { LoadingService } from './core/services/loading.service';
import { PRIMENG_PT_BR } from './core/i18n/primeng-ptbr';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    RouterOutlet,
    ToastModule,
    ProgressSpinnerModule,
    NgIf
  ],
  template: `
    <p-toast></p-toast>

    <!-- LOADING GLOBAL -->
    <div class="global-loading" *ngIf="loading.loading()">
      <p-progressSpinner></p-progressSpinner>
    </div>

    <router-outlet></router-outlet>
  `,
  styles: [`
    .global-loading {
      position: fixed;
      inset: 0;
      background: rgba(255, 255, 255, 0.6);
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 9999;
    }
  `]
})
export class App {

  loading = inject(LoadingService);
  router = inject(Router);
  primeng = inject(PrimeNG);

  constructor() {
    // this.router.events.subscribe(event => {

    //   if (event instanceof NavigationStart) {
    //     this.loading.show();
    //   }

    //   if (
    //     event instanceof NavigationEnd ||
    //     event instanceof NavigationCancel ||
    //     event instanceof NavigationError
    //   ) {
    //     this.loading.hide();
    //   }

    // });

    this.primeng.setTranslation(PRIMENG_PT_BR);
  }

  protected readonly title = signal('portal');
}
